// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1___e7004fdcb03e3fa38ae","cls2":"SuggestionCard-cls2__dabcbe2c544989eed587 SuggestionCard-cls1___e7004fdcb03e3fa38ae"};